import { connect } from 'react-redux';

import { IReduxState } from '../../types/redux';
import { Filters, IFiltersProps } from '../../components/Filters';
import { selectSpecialTabActive } from '../../hooks/selectors/specialTabs';

type TFiltersStateProps = Pick<IFiltersProps, 'jsonQuery' | 'specialTabActive'>;

export function mapStateToProps(state: IReduxState): TFiltersStateProps {
  return {
    jsonQuery: state.filters.jsonQuery,
    specialTabActive: selectSpecialTabActive(state),
  };
}

export const FiltersContainer = connect(mapStateToProps)(Filters);
